export default {"src":"/_next/static/media/loader_transparent.943ce9d4.gif","height":53,"width":200,"blurWidth":0,"blurHeight":0};